import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Iconify from 'src/components/iconify';
import CustomPopover, {usePopover} from 'src/components/custom-popover';
import Checkbox from '@mui/material/Checkbox/Checkbox';
import {useBoolean} from 'src/hooks/use-boolean';
import ConfirmDialog from '@components/custom-dialog/confirm-dialog';
import {Button} from '@mui/material';
import {useState} from 'react';
import RenderNoteDialog from './rendertheNoteOpen';
import CardAddnotes from './CardAddnotes';

// ----------------------------------------------------------------------
interface FileToUpload {
  ids: string;
  fileData: string; // Assuming base64-encoded string of the file's data
  fileName: string; // The name of the file
  fileType: string; // The MIME type of the file
  fileError: string;
}
interface WrittenData {
  id: string;
  isFavorited: boolean;
  title: string;
  description: string;
  date: string;
  attachmentName?: FileToUpload[];
}
type Props = {
  job: WrittenData;
  onView: VoidFunction;
  onEdit: VoidFunction;
  onDelete: VoidFunction;
};

export default function NoteItems({job, onView, onEdit, onDelete}: Props) {
  const popover = usePopover();
  const [note, setNote] = useState<WrittenData>(job);
  const [deleteitem, setDeleteitem] = useState(false);
  const [viewing, setViewing] = useState(false);
  const favorite = useBoolean(job.isFavorited);
  const [isDialogOpen, setisdialogOpen] = useState(false);
  const {id, title, date} = note;

  const renderAction = (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        top: 8,
        right: 8,
        position: 'absolute'
      }}>
      <Checkbox
        color="warning"
        icon={<Iconify icon="eva:star-outline" />}
        checkedIcon={<Iconify icon="eva:star-fill" />}
        checked={favorite.value}
        onChange={favorite.onToggle}
      />

      <IconButton
        color={popover.open ? 'inherit' : 'default'}
        onClick={popover.onOpen}>
        <Iconify icon="eva:more-vertical-fill" />
      </IconButton>
    </Stack>
  );
  const handlechange = () => {
    setDeleteitem(false);
  };
  const handleSaveNote = (vals: WrittenData) => {
    // Handle the save logic here
    setNote(vals);
    // console.log('data', vals);
  };

  return (
    <>
      <Card sx={{boxShadow:'0 2px 8px 0 rgb(11 124 237 / 96%)'}}>
        {renderAction}

        <Stack sx={{p: 1.625, pt: 3, pb: 0}}>
          <h6 style={{fontSize: 'xx-small', color: '#4a5561'}}>{date}</h6>
          <h3 style={{fontSize: 'larger', paddingTop: '0.8vh'}}>{title}</h3>
        </Stack>

        <Divider sx={{borderStyle: 'dashed', width: '33vh', margin: '1vh'}} />
        <Stack
          key={id}
          spacing={0.5}
          flexShrink={0}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{color: 'text.disabled', minWidth: 0, px: 1.625, pb: 2}}>
          <Typography variant="caption" noWrap>
            attachment
          </Typography>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M5 21q-.825 0-1.412-.587T3 19V5q0-.825.588-1.412T5 3h14q.825 0 1.413.588T21 5v14q0 .825-.587 1.413T19 21zm1-4h12l-3.75-5l-3 4L9 13z"
            />
          </svg>
        </Stack>
      </Card>

      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-top"
        sx={{width: 140}}>
        <MenuItem
          onClick={() => {
            popover.onClose();
            setViewing(true);
          }}>
          <Iconify icon="solar:eye-bold" />
          View
        </MenuItem>

        <MenuItem
          onClick={() => {
            popover.onClose();
            setisdialogOpen(true);
          }}>
          <Iconify icon="solar:pen-bold" />
          Edit
        </MenuItem>

        <MenuItem
          onClick={() => {
            popover.onClose();
            setDeleteitem(true);
          }}
          sx={{color: 'error.main'}}>
          <Iconify icon="solar:trash-bin-trash-bold" />
          Delete
        </MenuItem>
      </CustomPopover>
      <RenderNoteDialog
        item={note}
        favorited={favorite.value}
        onFavorite={favorite.onToggle}
        open={viewing}
        onClose={() => setViewing(false)}
        onDelete={() => {
          onDelete();
        }}
      />
      <ConfirmDialog
        open={deleteitem}
        onClose={() => handlechange()}
        title="Delete"
        content="Are you sure want to delete?"
        action={
          <Button variant="contained" color="error" onClick={onDelete}>
            Delete
          </Button>
        }
      />
      <CardAddnotes
        open={isDialogOpen}
        title="Edit Note"
        onClose={() => setisdialogOpen(false)}
        onCreate={false} // Fix: Remove the incorrect assignment of `false` to the `onCreate` prop.
        folderName={note}
        onEditSave={handleSaveNote}
      />
    </>
  );
}
